import PiPopupWindowPreview from "../previews/components/PiPopupWindowPreview";
import { useSelector } from "react-redux";
import { selectSelectedElement } from "../../app/slices/TrainingSlice";
import { IDynamicInteraction } from "../../models/interactions/DynamicInteraction";
import PiPopupWindowStaticTitle from "../previews/components/PiPopupWindowStaticTitle";
import DynamicInteractionPreviewBody from "./DynamicInteractionPreviewBody";
import usePropHelper from "../../hooks/PropHelper";
import { useMemo } from "react";
import CircleIcon from "@mui/icons-material/Circle";
export default function DynamicInteractionPreview() {
  const { getPropPresetByInstanceId } = usePropHelper();
  const interaction = useSelector(selectSelectedElement) as IDynamicInteraction;

  const source = useMemo(() => {
    return getPropPresetByInstanceId(interaction.source);
  }, [interaction.source]);

  const title = (
    <div className="flex items-center gap-[8px]">
      <div className="">
        <PiPopupWindowStaticTitle title={interaction.name} />
      </div>
      <div className="text-[8px] text-interaction-primary">
        <CircleIcon fontSize="inherit" color="inherit" />
      </div>
      <div className="flex-1 text-[20px] text-interaction-primary ">
        {source?.name}
      </div>
    </div>
  );

  return (
    <PiPopupWindowPreview
      body={<DynamicInteractionPreviewBody />}
      title={title}
    />
  );
}
